import { render } from "./Barrier.vue?vue&type=template&id=e0002b40"
import script from "./Barrier.vue?vue&type=script&lang=js"
export * from "./Barrier.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__